import React, { FC } from 'react';
import { format, parse } from 'date-fns';
import { useTranslation } from 'react-i18next';
import { LinearProgress, useMediaQuery } from '@mui/material';
import { useRepairWorkProgress } from '../../../../../hooks/useRepairWorkProgress';
import { IUserRepairWorks } from '../../../../../models/UserInfo';
import { WheelsIcon } from '../../../../commons/icons/Wheels';
import { TechMessages } from './TechMessages';

interface TechWorkProps {
  work: IUserRepairWorks;
}

export const TechWork: FC<TechWorkProps> = ({ work }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:767px)');
  const progressPercent = useRepairWorkProgress(work);
  const techMessages = t('technicalWorks.messages', { returnObjects: true }) as string[];

  return (
    <div className="service-cards-container__tech-works">
      <div className="animated-wheel">
        <WheelsIcon className="icon-wheel" />
      </div>
      <div className="tech-details">
        <div className="tech-details__title">
          {t('technicalWorks.technicalWorksIsBeingCarried')}{' '}
          {work.fromTime && work.fromDate === work.toDate ? (
            <span>
              {t('paymentHistory.paymentPeriodReceipt', {
                from: work.fromTime,
                to: work.toTime,
              })}
            </span>
          ) : (
            <span>
              {work.fromTime
                ? t('paymentHistory.paymentPeriodReceipt', {
                    from: `${format(parse(work.fromDate, 'yyyy-MM-dd', new Date()), 'dd.MM.yy')} ${work.fromTime}`,
                    to: `${format(parse(work.toDate, 'yyyy-MM-dd', new Date()), 'dd.MM.yy')} ${work.toTime}`,
                  })
                : t('technicalWorks.confirmTimeline')}
            </span>
          )}
        </div>
        {!isMobile && <div className="tech-details__reason">{work.Reason}</div>}
        {!isMobile && progressPercent !== null && (
          <div className="tech-details__progress">
            <LinearProgress variant="determinate" value={progressPercent} />
            <div className="passed-percent">{progressPercent}%</div>
          </div>
        )}
        {!isMobile && (
          <div className="tech-details__messages">
            <TechMessages messages={techMessages} />
          </div>
        )}
      </div>
      {isMobile && (
        <div className="tech-bottom">
          <div className="tech-bottom__reason">{work.Reason}</div>
          {progressPercent !== null && (
            <div className="tech-bottom__progress">
              <LinearProgress variant="determinate" value={progressPercent} />
              <div className="passed-percent">{progressPercent}%</div>
            </div>
          )}
          <div className="tech-bottom__messages">
            <TechMessages messages={techMessages} />
          </div>
        </div>
      )}
    </div>
  );
};
